import { useEffect } from "react";
import styled from "styled-components";

const TOAST_AUTO_DISMISS_MS = 3000;

const ToastBar = styled.div`
  position: fixed;
  top: max(12px, env(safe-area-inset-top));
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  max-width: 440px;
  z-index: 250;
  background: #111;
  color: #fff;
  border-radius: 10px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
`;

const Icon = styled.img`
  flex-shrink: 0;
`;

const Message = styled.span`
  flex: 1;
`;

interface AppToastProps {
  visible: boolean;
  message: string;
  iconUrl?: string;
  onDone: () => void;
}

export const AppToast = ({ visible, message, iconUrl, onDone }: AppToastProps) => {
  useEffect(() => {
    if (!visible) return;
    const t = window.setTimeout(onDone, TOAST_AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [visible, onDone]);

  if (!visible) return null;

  return (
    <ToastBar role="status">
      {iconUrl ? <Icon src={iconUrl} alt="" width={20} height={20} /> : null}
      <Message>{message}</Message>
    </ToastBar>
  );
};
